import { SketchPicker } from 'react-color';
import reactCSS from 'reactcss';
import { setStyle } from '../utility';
const equal = require( 'fast-deep-equal' );

const colorParse = require( 'color-parse' );
const { Component, Fragment } = wp.element;
const { applyFilters } = wp.hooks;

class ReactBorderColorPicker extends Component {
	constructor( props ) {
		super( props );

		//const col = colorParse(props.color);
		//let colObj = ReactBorderColorPicker.getStateColor(col);
		//console.log('1. CONSTRUCTOR: ', col, colObj);

		this.state = {
			displayColorPicker: false,
			color: '',
			disableAlpha: false,
			swatch: [],
			//swatch: ['#D0021B', '#F5A623', '#F8E71C', '#8B572A', '#7ED321', '#417505', '#BD10E0', '#9013FE', '#4A90E2', '#50E3C2', '#B8E986', '#000000', '#4A4A4A', '#9B9B9B', '#FFFFFF']
		};
	}

	static getDerivedStateFromProps( props, state ) {
		const col = colorParse( props.color );
		const tmpColObj = ReactBorderColorPicker.getStateColor( col );

		//console.log('%c getDerivedStateFromProps <ReactBorderColorPicker />: ', 'background: #222; color: #bada55', state, props);
		//console.log('+++<<<<<<<<<<<<<<<<<<<<<<<<<<<< getDerivedStateFromProps <ReactBorderColorPicker />: ', state, props, 'background: #222'; color: #bada55');

		//console.log('2. getDerivedStateFromProps: ', col, tmpColObj);
		//console.log('<<<<< getDerivedStateFromProps', tmpColObj, state.color);

		// expect CSS value to be empty, or 1,2,3,4 values
		if ( equal( tmpColObj, state.color ) ) {
			//console.log('%c EQUAL: DO NOTHING: ', 'background: green; color: #fff', state, props);
			return null;
		}
		//console.log('%c NOT EQUAL: UPDATING: ', 'background: red; color: #fff', state, props);
		const tmpState = { ...state };
		tmpState.color = tmpColObj;
		return tmpState;
	}

	componentDidMount() {
		//console.log('REACTCOLORPICKER: componentDidMount');
	}

	componentDidUpdate() {
		const cols = 'background: ' + this.state.color.hex + '; color: #fff';
		//console.log('%c COLOR: ', cols, this.state.color);
		//console.log('REACTCOLORPICKER: componentDidUpdate');
	}

	static getStateColor = ( col ) => {
		//console.log('COL COL COL::: ', col);
		const tmpObj = {};

		if ( Array.isArray( col.values ) ) {
			if ( typeof col.values[ 0 ] !== 'undefined' ) {
				tmpObj.r = col.values[ 0 ];
			} else {
				tmpObj.r = 255;
			}
			if ( typeof col.values[ 1 ] !== 'undefined' ) {
				tmpObj.g = col.values[ 1 ];
			} else {
				tmpObj.g = 255;
			}
			if ( typeof col.values[ 2 ] !== 'undefined' ) {
				tmpObj.b = col.values[ 2 ];
			} else {
				tmpObj.b = 255;
			}
			if ( typeof col.alpha !== 'undefined' ) {
				tmpObj.a = col.alpha;
			} else {
				tmpObj.a = 1;
			}
		}

		return tmpObj;
	};

	handleClick = () => {
		this.setState( {
			displayColorPicker: ! this.state.displayColorPicker,
		} );
	};

	handleClose = () => {
		this.setState( { displayColorPicker: false } );
	};

	handleChange = ( color ) => {
		const cols = 'background: ' + color.hex + '; color: #fff';
		//console.log('%c COLOR: ', cols, color);

		this.setState( { color: { r: 156, g: 235, b: 204, a: 1 } }, () => {
			const { updateColorProp, location } = this.props;

			// output rgb() or rgba()
			const colStr = this.state.disableAlpha
				? `rgb(${ color.rgb.r }, ${ color.rgb.g }, ${ color.rgb.b })`
				: `rgba(${ color.rgb.r }, ${ color.rgb.g }, ${ color.rgb.b }, ${ color.rgb.a })`;

			//let tmpObj = {};
			//tmpObj[location] = colStr;
			updateColorProp( colStr, location );
		} );
	};

	render() {
		const { title, colIndex } = this.props;

		//console.log('>>>>> RENDER REACTCOLORPICKER: ', `rgba(${this.state.color.r}, ${this.state.color.g}, ${this.state.color.b}, ${this.state.color.a})`, this.state.color, this.props.update);

		const styles = reactCSS( {
			default: {
				color: {
					width: '28px',
					height: '28px',
					borderRadius: '2px',
					background: `rgba(${ this.state.color.r }, ${ this.state.color.g }, ${ this.state.color.b }, ${ this.state.color.a })`,
				},
				swatch: {
					padding: '0',
					marginRight: '8px',
					marginBottom: '8px',
					background: '#fff',
					borderRadius: '1px',
					//border: '1px #aaa solid',
					boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
					display: 'inline-block',
					cursor: 'pointer',
				},
				popover: {
					position: 'absolute',
					zIndex: '2',
					left: '5px',
					top: '37px',
				},
				cover: {
					position: 'fixed',
					top: '0px',
					right: '0px',
					bottom: '0px',
					left: '0px',
				},
			},
		} );

		return (
			<Fragment>
				<div style={ styles.swatch } onClick={ this.handleClick }>
					<div style={ styles.color } />
				</div>
				{ this.state.displayColorPicker && (
					<div style={ styles.popover }>
						<div
							style={ styles.cover }
							onClick={ this.handleClose }
						/>
						<SketchPicker
							presetColors={ this.state.swatch }
							disableAlpha={ this.state.disableAlpha }
							color={ this.state.color }
							onChange={ this.handleChange }
						/>
					</div>
				) }
			</Fragment>
		);
	}
}

export default ReactBorderColorPicker;
